var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "smart-title"
  }, [_c("h2", [_vm._v(_vm._s(_vm.title))]), _c("p", [_vm._v(_vm._s(_vm.desc))])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };